import React from "react";
import { useLocation } from "react-router-dom";
import { TutorialProvider } from "./TutorialProvider";
import { TutorialOverlay } from "./TutorialOverlay";
import { getTutorialConfig } from "../../tutorial-config";

const EMPTY_CONFIG = {
  pageId: "none",
  pageTitle: "",
  steps: [],
};

export const TutorialRouteWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  const config = getTutorialConfig(location.pathname) ?? EMPTY_CONFIG;

  return (
    <TutorialProvider config={config}>
      {children}
      <TutorialOverlay />
    </TutorialProvider>
  );
};

export default TutorialRouteWrapper;
